/**
 * Thin GA4 event wrapper.
 * Routes all custom events through a single function that
 * no-ops when analytics consent has not been granted.
 *
 * Safe to call from non-component code (no React hooks).
 */
import ReactGA from 'react-ga4';
import { hasAnalyticsConsent } from '@/lib/consent';

/**
 * Fire a GA4 event if the user has granted analytics consent.
 * Silently no-ops otherwise (belt-and-braces on top of Consent Mode).
 */
export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  if (!hasAnalyticsConsent()) return;
  ReactGA.event(name, params);
}
